import { Navigate, useParams } from 'react-router';

import { ROUTES } from '#/config/routes';

const RedirectLegacyMiscPurchasePage = () => {
  const params = useParams();
  const rest = params['*'] ? `/${params['*']}` : '';

  return <Navigate to={`${ROUTES.miscPurchaseOrder}${rest}`} replace />;
};

export default RedirectLegacyMiscPurchasePage;
